module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_kimono@2x-c992451c4e9ff0c10c2194a621d3fe70.webp";